import statesUs from 'states-us';
import citiesUS from 'list-of-us-cities';

export const STATES = statesUs.map((state) => ({ title: state.name, value: state.abbreviation }));
export const CITIES = citiesUS;
